/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { getAPI } from "../../../utils/common";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Space, Button, Card, Layout, Table, Tag } from "antd";
import dayjs from "dayjs";

import { ALL_LAUNDRY_PAYMENT } from "../../../constants/api";

function PaymentTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);

    getAPI(
      ALL_LAUNDRY_PAYMENT,
      (data) => {
        if (data.status === true) {
          const formatted = data.data.map((row, index) => ({
            key: index,
            ID: index + 1,
            Vendor: row.vendor?.name || "-",
            Date: dayjs(row.payment_date).format("DD MMM YYYY"),
            Amount: `₹ ${row.amount}`,
            Mode: <Tag color="blue">{row.mode.toUpperCase()}</Tag>,
          }));
          setState(formatted);
        } else {
          setState([]);
        }
        setLoading(false);
      },
      () => {
        setState([]);
        setLoading(false);
      },
      {}
    );
  };

  const columns = [
    { title: "S.No", dataIndex: "ID", width: 70 },
    { title: "Vendor", dataIndex: "Vendor", width: 200 },
    { title: "Payment Date", dataIndex: "Date", width: 150 },
    { title: "Amount", dataIndex: "Amount", width: 150 },
    { title: "Mode", dataIndex: "Mode", width: 120 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Vendor Payments"
          extra={
            <Button onClick={() => navigate("/laundry/payment/add")}>
              Add <PlusOutlined />
            </Button>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={state}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 700 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default PaymentTable;
